import { ICartSummaryRequestBody, ICartSummaryResponse } from "@app-rest/cart.interfaces";
import type { ProcessTokenResponse } from "@qamf/payments";
import { useCloudBackend } from "@qamf/shell-app-sdk";

export default function useCartRestClient() {
	const { post, getOption } = useCloudBackend();

	function cartSummary(centerId: number, data: ICartSummaryRequestBody) {
		const headers = getOption("headers");
		headers.set("Content-Type", "application/json");

		return post<ICartSummaryResponse>(`/centers/${centerId}/Cart/CreateSummary`, {
			body: data,
			cacheInMemory: false,
			headers
		});
	}

	function squareSdkConfirm(centerId: number, data: {Token: string, OperationId: string}) {
		const headers = getOption("headers");
		headers.set("Content-Type", "application/json");

		return post<ProcessTokenResponse>(`/centers/${centerId}/payment/token`, {
			body: data,
			cacheInMemory: false,
			headers
		});
	}

	return {
		cartSummary,
		squareSdkConfirm
	};
}
